export default __webpack_public_path__ + "static/media/sedi.53c4baa7.svg";